<template>
    <!-- 원청 · 프로젝트 화면 셸 — 사내 디자인 시스템 TopNavShell 과 같은 조립: 상단 바(TopNav) · 화면 제목 자리(PageHeader) · 본문.
         화면 제목 내용은 화면의 <admin-page-header> 가 정하고, 자리는 여기 한 번만 둔다(관리자 셸 layout-admin 과 같은 방식). -->
    <div class="ds-top-shell">
        <router-view name="header"></router-view>

        <admin-page-header-view v-if="pageHeader" :header="pageHeader.header"/>

        <router-view class="min-vh-100 ds-top-main"></router-view>

        <router-view name="footer"></router-view>
    </div>
</template>

<script>
import AdminPageHeaderView from '@shared_components/admin/components/common/AdminPageHeaderView.vue';

export default {
    name: "AdminMaster",
    components: {AdminPageHeaderView},
    provide () {
        // 화면이 바뀌는 순간 새 화면이 먼저 생기고 옛 화면이 나중에 사라지므로, 지울 때는 «지금 주인»일 때만 지운다
        return {
            adminShell: {
                setPageHeader: (owner, header) => { this.pageHeader = {owner, header} },
                clearPageHeader: owner => { if (this.pageHeader && this.pageHeader.owner === owner) this.pageHeader = null },
            },
        };
    },
    data () {
        return {
            pageHeader: null,
        };
    },
}
</script>

<style>
/* 본문 안에서 위에 붙는(sticky) 요소가 상단 바 아래에 서도록 높이를 알려 준다.
   바탕은 DS --background(옅은 회색) — 표 · 카드는 자기 흰 판을 갖는다(관리자 셸과 같음) */
.ds-top-shell {
    --ds-shell-header-h: 48px;
    background-color: var(--ds-background);
}

/* 휴대폰 폭에서는 상단 바가 두 줄(48 + 40) */
@media (max-width: 767.98px) {
    .ds-top-shell {
        --ds-shell-header-h: 88px;
    }
}

/* 본문 위 16 — 제목 판(PageHeader) 아래 선과 첫 카드 사이(DS Main 16). 전에는 큰 배너의 아래 여백(48)이 이 자리였다 */
.ds-top-main {
    padding-top: 16px;
}

/* 옛 옅은 회색 판(bgray-100)은 바탕과 같은 색이라 회색 바탕 위에서 사라진다 — 셸 안에서는 흰 판으로(표 안 줄 강조는 그대로) */
.ds-top-shell .bgray-100:not(tr):not(td) {
    background-color: var(--ds-surface) !important;
}

/* 넓은 표 화면의 본문 — 화면 폭 · 좌우 16 · 최대 1680(DS Main). <b-container fluid class="ds-top-body"> 로 쓰고 제목은 contained 없이 */
.ds-top-body {
    max-width: 1680px;
    padding-left: 16px;
    padding-right: 16px;
}
</style>
